import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Box, Button, DialogTitle, Divider, Grid, Stack, Table, TableCell, TableRow } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { colors } from '../../../global/helpers';
ChartJS.register(ArcElement, Tooltip, Legend);

export function RatingGraph({ rating_medium }) {
    const graph = {
        labels: ['Avaliação média', ''],
        datasets: [
            {
                label: 'Avaliação média',
                data: [Number(rating_medium[0].rating_medium).toFixed(2), Number(rating_medium[0].rating_medium).toFixed(2) - 5],
                backgroundColor: ['#1c630e', '#e5ac0e', '#f6f6f6'],
            },
        ],
    };
    return (
        <Card elevation={2} sx={{ borderRadius: '8px', flexGrow: 1, py: 5, alignItems: 'center' }}>
            <CardContent>
                <Grid direction="row" container px={2} spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="h3" sx={{ mb: 3, color: '#284db9' }}>
                            Média de avaliação
                        </Typography>
                        <Typography variant="h3" sx={{ mb: 3, fontSize: 33, color: '#1c630e' }}>
                            {Number(rating_medium[0].rating_medium).toFixed(2)}
                        </Typography>
                    </Grid>

                    <Grid item xs={5}>
                        <Doughnut width={200} height={200} options={{ responsive: true, plugins: { legend: { display: false } } }} data={graph} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
